/** Extract a user-facing message from a Nuxt/ofetch error. */
export function fetchErrorMessage(
  err: unknown,
  fallback = "Something went wrong — please try again.",
): string {
  if (!err || typeof err !== "object") return fallback;

  const e = err as {
    statusMessage?: string;
    message?: string;
    data?: { statusMessage?: string; message?: string; errors?: string[] };
  };

  if (e.data?.errors?.length) return e.data.errors.join(" ");
  if (e.statusMessage) return e.statusMessage;
  if (e.data?.statusMessage) return e.data.statusMessage;
  if (e.message && !e.message.includes("<!DOCTYPE")) return e.message;
  if (e.data?.message && typeof e.data.message === "string") {
    return e.data.message;
  }

  return fallback;
}
